module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.b44291ba.png";